export {
  addEmptyColumns,
  addRowsTotals,
  addColumnsTotals,
  formattingRows
}

function addEmptyColumns(rows) {
  const uniqueColumns = Object.keys(rows.reduce((map, row) => Object.assign(map, row), {}));
  const fillObj = uniqueColumns.reduce((i, key) => (i[key] = 0, i), {});
  return rows.map(row => Object.assign({}, fillObj, row));
}

function addRowsTotals(rows = [], rowFields = [], fields = []) {
  const notCalcFieldsMap = getNotCalcFieldsMap(rows[0], [...rowFields, ...fields]);
  return rows.map((row) => {
    const copy = Object.assign({}, row);
    copy.totals = Object.keys(copy).reduce((sum, key) => {
      if (isCalculatedField(key, notCalcFieldsMap)) {
        sum += (+copy[key]);
      }

      return sum;
    }, 0);

    return copy;
  });
}

function addColumnsTotals(rows = [], rowFields = [], fields = []) {
  const notCalcFieldsMap = getNotCalcFieldsMap(rows[0], [...rowFields, ...fields]);
  const sums = {};
  return [...rows.map((row) => {
    Object.keys(row).forEach((key) => {
      if (isCalculatedField(key, notCalcFieldsMap)) {
        if (!(key in sums)) {
          sums[key] = 0;
        }

        sums[key] += (+row[key]);
      } else {
        sums[key] = null
      }
    }, sums);

    return row;
  }), sums];
}


function formattingRows(rows, rowFields, fields) {
  const notCalcFieldsMap = getNotCalcFieldsMap(rows[0], [...rowFields, ...fields]);
  const rowFieldsLabelsKeys = getFieldsLabelsKeys(rowFields);
  const formattRowFields = (row) => {
    const copyRowFields = Object.assign({}, row);
    const priorityRowFields = rowFieldsLabelsKeys.reduce((fields, key) => {
        fields[key] = copyRowFields[key];
        delete copyRowFields[key];
        return fields;
      }, {});
    const rowFactory = (fields) => Object.keys(fields)
      .map(key => ({
        key, 
        value: fields[key], 
        calculated: isCalculatedField(key, notCalcFieldsMap) || key === 'totals'
      }));
    return [...rowFactory(priorityRowFields), ...rowFactory(copyRowFields)];
  };

  return rows.map(formattRowFields)

}

function isCalculatedField(fieldKey, notCalcFieldsMap) {
  return fieldKey === '$count' || !notCalcFieldsMap[fieldKey];
}

function getNotCalcFieldsMap(row, fields = []) {
   const fieldsLabelsKeys = getFieldsLabelsKeys(fields);
   return Object.keys(row || {}).reduce((map, key) => {
    if (fieldsLabelsKeys.includes(key)) {
      map[key] = true;
    }

    return map
   }, {});
}

function getFieldsLabelsKeys(fields) {
  return fields.map(field => field.label);
}